import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ImagePreviewService } from '../../services/image-preview.service';

@Component({
  selector: 'app-image-preview-dialog',
  templateUrl: './image-preview-dialog.component.html'
})
export class ImagePreviewDialogComponent implements OnInit, OnDestroy {

  private openSub: Subscription;

  constructor(
    public imagePreviewService: ImagePreviewService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.openSub = this.imagePreviewService.openEvent.subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.openSub?.unsubscribe();
  }

  closePreview() {
    this.imagePreviewService.close();
  }
}
